<template>
  <div class="dashboard-list">
    <ul class="dashboard-list__container">
      <li v-for="(item,key) in modulesList" :key="key">
        <div class="dashboard-list__lists">
          <div class="dashboard-list__image">
            <img :src="imgUrl + item.logo" />
          </div>
          <div class="dashboard-list__description">
            <p>{{item.description}}</p>
            <div>
              <span :class="{'active':item.status === 1}">
                <i class="fa fa-star" aria-hidden="true"></i>
                {{item.status === 1 ? '已启用' : '已禁用'}}
              </span>
              <span>{{item.name}}</span>
            </div>
          </div>
        </div>
        <div class="dashboard-list__mask">
          <span @click="handleClick(item.id,'check')">查看</span>
          <span @click="preview(item.id)">预览</span>
          <span @click="handleClick(item.id,'edit')">编辑</span>
          <span @click="deleteRow(item.id)">删除</span>
          <span
            @click="changeState(item,item.status)"
          >{{item.status === 1 ? '禁用' : '启用'}}</span>
        </div>
      </li>
    </ul>
    <div class="dashboard-list__dialog">
      <el-dialog
        title="模式信息"
        :visible.sync="editModalVisible"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :append-to-body="true"
      >
        <el-form
          :model="editModal"
          autocomplete="on"
          :rules="rules"
          ref="editForm"
          :disabled="disabled"
        >
          <el-form-item label="模式名称：" :label-width="LabelWidth" prop="name">
            <el-input
              v-model="editModal.name"
              autocomplete="off"
              clearable
              @keyup.enter.native="submitCheckForm"
            ></el-input>
          </el-form-item>
          <el-form-item label="首页地址：" :label-width="LabelWidth" prop="address">
            <el-input
              v-model="editModal.address"
              autocomplete="off"
              clearable
              @keyup.enter.native="submitCheckForm"
            ></el-input>
          </el-form-item>
          <el-form-item label="模式描述：" :label-width="LabelWidth" prop="description">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5}"
              clearable
              placeholder="请输入内容"
              v-model="editModal.description"
              @keyup.enter.native="submitCheckForm"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="刷新时间：" :label-width="LabelWidth" prop="modelRefreshTime">
            <el-select v-model="editModal.modelRefreshTime" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.label"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>-->
          <el-form-item label="logo图片：" :label-width="LabelWidth" prop="logo">
            <el-upload
              class="table__avatar"
              :action="this.uploadURL"
              :show-file-list="false"
              list-type="picture"
              :on-success="EditAvatarSuccess"
              :before-upload="beforeEditAvatarUpload"
            >
              <img
                v-if="editModal.logo"
                :src="this.imgUrl + editModal.logo"
                class="table__image"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeForm" v-show="type !== 'check'">取 消</el-button>
          <el-button type="primary" @click="submitCheckForm">{{type === 'check' ? '关闭' : '保存' }}</el-button>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="iframeDialog" width="80%" center :append-to-body="true">
        <iframe width="100%" height="600px" :src="iframeSrc" frameborder="0"></iframe>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modulesList: Array
  },
  data() {
    return {
      // userType:JSON.parse(this.$store.getters.userId),
      type: "check",
      disabled: false,
      editModalVisible: false,
      LabelWidth: "100px",
      editModal: {
        name: "",
        address: "",
        description: "",
        logo: "",
        id: "",
        status: "",
        type:'',
      },
      rules: {
        name: [
          { required: true, trigger: "blur", message: "请输入模式名称" }
        ],
        address: [{ required: true, message: "请输入首页地址" }],
        description: [{ required: true, message: "请输入描述信息" }],
        modelRefreshTime: [{ required: true, message: "请输入刷新时间" }],
        logo: [{ required: true, message: "请上传logo图片" }]
      },
      iframeDialog: false,
      iframeSrc: "",
    };
  },
  methods: {
    EditAvatarSuccess(res, file) {
      this.editModal.logo = res.data.store_result;
    },

    beforeEditAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 10MB!");
      }
      return isLt2M;
    },

    /* check && edit*/
    handleClick(key, type) {
      this.editModalVisible = true;
      this.type = type;
      this.http.get(`${urlConfig.devUrl}apij2/admin-api/trade/mode/get?id=`+key).then(res=>{
          if(res.code==0){
              this.editModal=res.data
          }
      })
    },

    /*preview*/
    preview(key) {
        this.http.get(`${urlConfig.devUrl}apij2/admin-api/trade/mode/get?id=`+key).then(res=>{
          if(res.code==0){
              this.iframeSrc=res.data.address
              console.log(this.iframeSrc)
              this.iframeDialog = true;
          }
      })
    },

    /* delete*/
    deleteRow(key) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
            this.http.delete(`${urlConfig.devUrl}apij2/admin-api/trade/mode/delete?id=`+key).then(res=>{
                if(res.code == 0){
                    this.$message.success('删除成功')
                    this.$emit('updateEditModulesList')
                }
            })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    //start
    changeState(val, status) {
      let params = {
        status: status === 1 ? 2 : 1,
        type: val.type,
        id: val.id
      };
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/mode/update`,params).then(res=>{
          if(res.code == 0){
              this.$message.success('操作成功');
              this.$emit('updateEditModulesList')
          }
      })
    },

    /* submit&&check*/
    submitCheckForm() {
      if (this.type === "check") {
        this.editModalVisible = false;
      } else {
        this.$refs["editForm"].validate(valid => {
          if (valid) {
              this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/mode/update`,this.editModal).then(res=>{
                  if(res.code == 0){
                      this.closeForm();
                      this.$message.success('保存成功');
                      this.$emit('updateEditModulesList')
                  }
              })
          } else {
            return false;
          }
        });
      }
    },

    //cancel
    closeForm() {
      this.$refs["editForm"].resetFields();
      this.editModalVisible = false;
    }
    
  }
};
</script>

<style lang="scss" scoped>
@include component(dashboard-list) {
  width: 100%;
  .dashboard-list__container {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    li {
      width: calc(100% / 3 - 1rem);
      margin-bottom: 1rem;
      margin-right: 1rem;
      position: relative;
      cursor: pointer;
      height: 24.75rem;

      &:hover {
        .dashboard-list__mask {
          filter: alpha(opacity=100);
          opacity: 1;
        }
        .dashboard-list__lists {
          .dashboard-list__image {
            overflow: hidden;
            img {
              transform: scale(1.1, 1.1);
            }
          }
        }
      }
    }
  }

  .dashboard-list__description {
    box-shadow: 0px 0 2px #c1c1c1 !important;
    background: none;
    padding: 1rem;
    height: 6rem;

    p {
      font-size: 0.875rem;
      color: #525254;
      text-align: left;
      padding: 0;
      margin: 0;
    }

    div {
      display: flex;
      justify-content: space-between;
      padding-top: 0.8rem;
      font-size: 0.875rem;
      span {
        &:nth-of-type(1) {
          color: #ffa534;
        }
        &:nth-of-type(2) {
          color: #9e9e9e;
        }
      }
      .active {
        color: #1dc7ea !important;
      }
    }
  }

  .dashboard-list__image {
    width: 100%;
    height: 18.75rem;

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }

  .dashboard-list__mask {
    width: 100%;
    height: 100%;
    position: absolute;
    overflow: hidden;
    top: 0;
    left: 0;
    filter: alpha(opacity=0);
    opacity: 0;
    background-color: rgba(118, 66, 184, 0.8);
    transition: all 0.4s ease-in-out;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    span {
      font-size: 0.875rem;
      padding: 0.5rem 1.5rem;
      border-radius: 5px;
      margin: 0.5rem 0;
      cursor: pointer;
      transition: all 0.3s;
      &:nth-of-type(1) {
        border: 1px solid #4ad2ee;
        color: #4ad2ee;
      }
      &:nth-of-type(1):hover {
        background: #4ad2ee;
        color: #ffffff;
        transform: scale(1.1);
      }
      &:nth-of-type(2) {
        border: 1px solid #ff0099;
        color: #ff0099;
      }
      &:nth-of-type(2):hover {
        background: #ff0099;
        color: #ffffff;
        transform: scale(1.1);
      }
      &:nth-of-type(3) {
        border: 1px solid #85ce61;
        color: #85ce61;
      }
      &:nth-of-type(3):hover {
        background: #85ce61;
        color: #ffffff;
        transform: scale(1.1);
      }
      &:nth-of-type(4) {
        border: 1px solid #fb404b;
        color: #fb404b;
      }
      &:nth-of-type(4):hover {
        background: #fb404b;
        color: #ffffff;
        transform: scale(1.1);
      }
      &:nth-of-type(5) {
        border: 1px solid #ffa534;
        color: #ffa534;
      }
      &:nth-of-type(5):hover {
        background: #ffa534;
        color: #ffffff;
        transform: scale(1.1);
      }
    }
  }
}
  /*上传图片*/
  .is_border {
    border: 1px dashed #ddd !important;
    border-radius: 5px;
    height: 178px !important;
    line-height: 178px !important;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }

  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 178px;
    height: 178px;
    display: block;
  }

  .avatar-uploader {
    text-align: center;
    width: 178px;
    height: 178px;
  }

  /deep/ .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .table__image {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>